import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartjsGaugeComponent } from './chartjs-gauge/chartjs-gauge.component';



@NgModule({
  declarations: [
    ChartjsGaugeComponent
  ],
  imports: [
    CommonModule
  ],
  exports:[
    ChartjsGaugeComponent
  ]
})
export class PCChartsModule { }
